export const formFields = {
  chatMessage: 'chatMessage',
}
